import validate from "/home/runner/work/studio-web-app/studio-web-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/home/runner/work/studio-web-app/studio-web-app/middleware/01.auth.global.ts";
import _02_45feat_45global from "/home/runner/work/studio-web-app/studio-web-app/middleware/02.feat.global.ts";
import _03_45onboarding_45global from "/home/runner/work/studio-web-app/studio-web-app/middleware/03.onboarding.global.ts";
import _04_45organization_45slug_45global from "/home/runner/work/studio-web-app/studio-web-app/middleware/04.organization-slug.global.ts";
import _05_45access_45global from "/home/runner/work/studio-web-app/studio-web-app/middleware/05.access.global.ts";
import _06_45user_45role_45global from "/home/runner/work/studio-web-app/studio-web-app/middleware/06.user-role.global.ts";
import _07_45permission_45global from "/home/runner/work/studio-web-app/studio-web-app/middleware/07.permission.global.ts";
import manifest_45route_45rule from "/home/runner/work/studio-web-app/studio-web-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45feat_45global,
  _03_45onboarding_45global,
  _04_45organization_45slug_45global,
  _05_45access_45global,
  _06_45user_45role_45global,
  _07_45permission_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "require-super-admin": () => import("/home/runner/work/studio-web-app/studio-web-app/middleware/require-super-admin.ts"),
  "require-top-window": () => import("/home/runner/work/studio-web-app/studio-web-app/middleware/require-top-window.ts")
}